// @ts-nocheck
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";
import Typography from "@store/MobiusOverrides/Typography/Typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React from "react";
import { css } from "styled-components";

const mobileQuery = getMediaQuery({ option: "only", first: true, min: 0, max: 480, last: false });
interface PriceMatrixProps {
    pricing?: ProductPriceDto | null;
    extendedStyles?: PriceMatrixStyles;
    overrideStyles?: PriceMatrixStyles;
}

export interface PriceMatrixStyles {
    header?: TypographyProps;
    priceBreakGridItemHeader?: InjectableCss;
    priceBreakGridItem?: InjectableCss;
    matrixRow?: InjectableCss;
    wrapper?: InjectableCss;
}
const priceBreakGridMixin = css`
    flex-basis: 100%;
    text-align: center;
    outline: 1px solid ${getColor("common.border")};
    padding: 0.5rem 0.125rem;
    ${mobileQuery} {
        font-size: ${pxToRem(14)};
    }

    background-color: ${getColor("common.background")};
`;

export const priceMatrixStyles: PriceMatrixStyles = {
    wrapper: {
        css: css`
            margin-block: ${({ theme }) => theme.design.layout.spacing.small};
            width: 100%;
        `,
    },
    matrixRow: {
        css: css`
            display: flex;
            width: 100%;
        `,
    },
    header: {
        variant: "h5",
        css: css`
            width: 100%;
            margin-bottom: 0;
            font-size: ${pxToRem(16)};
            text-align: center;
            vertical-align: middle;
            background-color: ${getColor("primary")};
            color: ${getColor("common.accent")};
            ${mobileQuery} {
                font-size: ${pxToRem(16)};
            }
        `,
    },
    priceBreakGridItemHeader: {
        css: css`
            ${priceBreakGridMixin}
            color: ${getColor("text.main")};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
    priceBreakGridItem: {
        css: css`
            ${priceBreakGridMixin}
            color: ${getColor("secondary")};
        `,
    },
};

const PriceMatrix: React.FC<PriceMatrixProps> = ({ pricing, extendedStyles, overrideStyles }) => {
    const pricingFromContext = useProductContext().productInfo?.pricing;
    const pricingToUse = pricing || pricingFromContext;
    const breakPricing = pricingToUse?.actualBreakPrices;
    const styles = useExpandProps(priceMatrixStyles, extendedStyles, overrideStyles);

    const showPriceMatrixSetting = useSettingsCollection().bunzlSettings?.showPriceMatrix;
    if (!pricingToUse || !breakPricing || breakPricing.length === 0 || !showPriceMatrixSetting) {
        return null;
    }

    const breakPricesWithoutSinglePrice = breakPricing.filter(priceBreak => priceBreak.breakQty > 1);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.header}> {translate("price breaks").toUpperCase()}</Typography>
            <StyledWrapper {...styles.matrixRow}>
                {breakPricesWithoutSinglePrice.map((priceBreak, index, array) => (
                    <StyledWrapper {...styles.priceBreakGridItemHeader} key={index.toString()}>
                        {/* {`${priceBreak.qty}${array?.[index + 1]?.qty ? ` - ${array?.[index + 1]?.qty - 1} ` : "+"}`} */}
                        {`${priceBreak.breakQty} +`}
                    </StyledWrapper>
                ))}
            </StyledWrapper>
            <StyledWrapper {...styles.matrixRow}>
                {breakPricesWithoutSinglePrice.map((priceBreak, index) => (
                    <StyledWrapper {...styles.priceBreakGridItem} key={priceBreak.breakQty}>
                        {priceBreak.breakPriceDisplay}
                    </StyledWrapper>
                ))}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default PriceMatrix;
